import { DASHBOARD_BAR_COLOR } from "@/shared/utils/dashboardConfig";
import React from "react";

const ColouredBar = ({ value }) => {
  return (
    <div className="flex-1 h-2 bg-gray-100 dark:bg-gray-800 rounded-full overflow-hidden">
      <div
        className="h-full rounded-full transition-all duration-500"
        style={{
          width: `${value}%`,
          backgroundColor: DASHBOARD_BAR_COLOR(value),
        }}
      />
    </div>
  );
};

export default ColouredBar;
